import { Component, Inject, OnInit } from '@angular/core';
import * as moment from 'moment';
import { SessionService } from '../../services/session.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccessControlValidationErrors, ISession } from '../../../typings';
import { WsService } from '../../services/ws/ws.service';
import { LogoutService } from '../../services/logout.service';

export interface IWelcomeDialogData {
     success: boolean;
     session: ISession;
     error: AccessControlValidationErrors;
}

@Component({
     selector: 'app-welcome-dialog',
     templateUrl: './welcome-dialog.component.html',
     styleUrls: ['./welcome-dialog.component.scss'],
})
export class WelcomeDialogComponent implements OnInit {
     isMorning = false;
     user: ISession;
     selected = null;
     quizSaved = false;
     successDialog: boolean;
     errorCode: AccessControlValidationErrors;

     constructor(
          private session: SessionService,
          private dialogRef: MatDialogRef<any>,
          private router: Router,
          private ws: WsService,
          private logoutService: LogoutService,
          @Inject(MAT_DIALOG_DATA) public data: IWelcomeDialogData
     ) {
          let currentHour = moment().get('hour');
          this.isMorning = currentHour >= 6 && currentHour <= 19;
          if (data && data.error) {
               this.user = data.session;
               this.successDialog = false;
               this.errorCode = data.error;
          } else {
               this.user = this.session.get();
               this.successDialog = true;
               this.errorCode = null;
          }
     }

     checkItem(item) {
          this.selected = item;
     }

     ngOnInit() {}

     save() {
          this.quizSaved = true;
          this.session.answerInitialQuestion();
     }

     goToScheduler() {
          this.dialogRef.close();
     }

     quit() {
          this.logoutService
               .run()
               .then(() => {
                    this.dialogRef.close();
               })
               .catch(() => {
                    this.dialogRef.close();
               });
     }
}
